import React from "react";
import withStyles from '@mui/styles/withStyles';
import {
  GET_CAMPAIGN_QUERY,
  GET_STATISTICS_QUERY,
  CURRENT_USER_QUERY,
} from "../../queries/queries";
import { useQuery } from "@apollo/client";
import Error from "../error";
import Loading from "../loading";
import CouponCampaignDetailContent from "../coupons-shared/coupon-campaign-detail-content";
import BoughtControl from "./bought-control";
import useMakeScrollable from "custom_hooks/make-scrollable";

const styles = (theme) => ({
  root: {
    background: "white",
    minHeight: "100vh",
  },
});

const CouponCampaignDetail = ({
  match: {
    params: { campaignId },
  },
  classes,
}) => {
  useMakeScrollable()

  const statisticsResult = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache",
  });
  const campaignResult = useQuery(GET_CAMPAIGN_QUERY, {
    variables: { id: campaignId },
    fetchPolicy: "no-cache",
  });
  const currentUser = useQuery(CURRENT_USER_QUERY, {
    fetchPolicy: "no-cache",
  });

  if (campaignResult.loading || currentUser.loading)
    return <Loading />;

  if (campaignResult.error || campaignResult.error || currentUser.error)
    return <Error />;

  const campaign = campaignResult.data.campaign;
  if (new Date(campaign.expiresAt) < new Date()) {
    return <Error />;
  }

  return (
    <div>
      <div className="scrollabe coupon-details">
        <CouponCampaignDetailContent campaign={campaign} />
      </div>
    </div>
  );
};
export default withStyles(styles)(CouponCampaignDetail);
